import React from 'react';
import styles from './press-card.module.scss';

type PressCardData = {
	date: string;
	direction: string;
	excerpt: string;
	id: string;
	image: string;
	index: number;
	link: string;
	source: string;
	title: string;
};

type PressCardProps = {
	data: PressCardData;
};

export const PressCard = ({ data }: PressCardProps) => {
	return (
		<a
			href={data.link}
			target="_blank"
			rel="noreferrer"
			className={`${styles.press_card} ${styles[data.direction]}`}
		>
			<div className={styles.press_card_image_container}>
				<img src={data.image} alt={data.title} />
			</div>
			<div className={styles.press_card_date}>{data.date}</div>
			<div className={styles.press_card_title}>{data.title}</div>
			<div className={styles.press_card_excerpt}>{data.excerpt}</div>
		</a>
	);
};

export default PressCard;
